import { Component, OnInit } from '@angular/core';
import { COMMON_IMPORTS } from '../../global-misc/common-imports';
import { CalendarModule } from 'primeng/calendar';
import { CrudVisitFacade, CrudVisitUiState } from './crud-visit.facade';
import { DividerModule } from 'primeng/divider';
import { CrudMeasurementComponent } from './crud-measurement/crud-measurement.component';
import { Eye } from '../../global-data-models/visit.model';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-add-visit',
  standalone: true,
  imports: [...COMMON_IMPORTS, CalendarModule, DividerModule, CrudMeasurementComponent, ConfirmDialogModule],
  providers: [ConfirmationService],
  templateUrl: './crud-visit.component.html',
})
export class CrudVisitComponent implements OnInit {
  public readonly Eye = Eye;

  public uiState: CrudVisitUiState = this.facade.EMPTY_ADD_VISIT_UI_STATE;
  private orgId!: string;
  private patientId!: string;
  private visitId?: string;

  public constructor(
    private readonly facade: CrudVisitFacade,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly confirmationService: ConfirmationService,
  ) {}

  public async ngOnInit() {
    // Get route parameters
    this.orgId = this.route.snapshot.params['orgId'];
    this.patientId = this.route.snapshot.params['patientId'];
    this.visitId = this.route.snapshot.paramMap.get('visitId') ?? undefined;

    this.facade.uiStateEvent$.subscribe((state: CrudVisitUiState) => {
      this.uiState = state;
    });

    await this.facade.begin(this.visitId ? 'update' : 'create', this.orgId, this.patientId, this.visitId);
  }

  public getFormChild(name: string): FormGroup | undefined {
    return this.uiState?.form.get(name) as FormGroup;
  }

  public async onSubmit(calculatePremo: boolean) {
    // Mark form as touched to show validation errors
    this.uiState.form.markAllAsTouched();

    if (this.uiState.form.invalid) {
      return;
    }

    //Check if any eye measures dont have axial or k value
    if (this.facade.shouldShowWarning()) {
      this.confirmationService.confirm({
        header: 'Adding a Visit Without a K-Value or Axial Length',
        message:
          'One or more of the eye measurements are missing an Axial Length or K-Value. This **may reduce the amount of data and scores that can be shown**. Are you sure you want to proceed?',
        acceptLabel: 'Yes, proceed',
        rejectLabel: 'No, go back',
        accept: async () => {
          await this.submitToFacade(calculatePremo);
        },
      });
      return;
    }

    await this.submitToFacade(calculatePremo);
  }

  private async submitToFacade(calculatePremo: boolean) {
    const success: boolean = await this.facade.onSubmit();

    if (success && calculatePremo) {
      this.router.navigate(['orgs', this.orgId, 'patients', this.patientId, 'calculate-premo']);
    }

    if (success && !calculatePremo) {
      await this.router.navigate(['/orgs', this.orgId, 'patients', this.patientId, 'manage']);
    }
  }
}
